import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { config, PERMISSIONS_SERVICE_REQUEST_PARAM } from './constants';
import { Subject, Observable } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class AuthorizationService {

  ENTITLEMENT_ADMIN_ROLE_NAME = 'EntitlementAdministrator';
  roles: any;
  currentRole: any;
  permissions: any; // Store the actions for which this user has permission
  permissionsSubject = new Subject();

  constructor(private httpClient: HttpClient) { }

  hasPermission(permissionType) {
    if (this.permissions && this.permissions.find(permission => {
      const permType = permission.action + '.' + permission.resource;
      return permType === permissionType;
    })) {
      return true;
    }
    return false;
  }

  // This method is called once and a list of permissions is stored in the permissions property
  initializePermissions() {
    return this.getPermissions();
  }

  getPermissions() {
    return new Promise((resolve, reject) => {
      const url = `${config.baseUrl}/permissions/${config.applicationGearId}?${PERMISSIONS_SERVICE_REQUEST_PARAM}`;
      this.httpClient.post(url, {}).subscribe((initialRes) => {
        this.permissions = initialRes;
        this.sendMessage('PERMISSIONS_RECEIVED');
        return resolve(this.permissions);
      });
    });
  }

  sendMessage(tp, dt?) {
    this.permissionsSubject.next({
      type: tp,
      data: dt
    });
  }

  clearMessage() {
    this.permissionsSubject.next();
  }

  getMessage(): Observable<any> {
    return this.permissionsSubject.asObservable();
  }
}
